import { Box, Button, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router';
import PersonAddIcon from '@mui/icons-material/PersonAdd'; // Import the icon

import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';

const SignupCallToAction = () => {
	const theme = useTheme();
	const navigate = useNavigate();
	return (
		<Box
			sx={{
				mt: 4,
				py: 2,
				px: 3,
				backgroundColor: theme.palette.background.paper,
				border: `1px solid ${theme.palette.divider}`,
				borderRadius: 3,
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
			}}
		>
			<Typography variant='body1' fontWeight={600} color='secondary'>
				If you don&apos;t have an account with our customer portal.
			</Typography>
			<Button
				size='large'
				variant='text'
				color='secondary'
				startIcon={<PersonAddIcon />}
				onClick={() => {
					navigate(ROUTE_PATHS.register);
				}}
			>
				Sign Up Now
			</Button>
		</Box>
	);
};

export default SignupCallToAction;
